<template>
  <b-modal id="modal-api-credentials" hide-footer scrollable>
    <template #modal-header>
      <h4>
        {{
          data.id === null
            ? $t("colleges.colegium.new")
            : $t("colleges.colegium.edit")
        }}
      </h4>
    </template>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onSubmit)">
        <div class="new-user-info">
          <b-row class="justify-content-md-center">
            <b-form-group
              class="col-md-12"
              :label="$t('colleges.colegium.username')"
              label-for="username"
            >
              <ValidationProvider
                :name="$t('colleges.colegium.username')"
                rules="required"
                v-slot="{ errors }"
              >
                <b-form-input
                  v-model="data.username"
                  type="text"
                  :placeholder="$t('colleges.colegium.username')"
                  :class="errors.length > 0 ? ' is-invalid' : ''"
                >
                </b-form-input>
                <div class="invalid-feedback">
                  <span>{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </b-form-group>
            <b-form-group
              class="col-md-12"
              :label="$t('colleges.colegium.college_code')"
              label-for="college_code"
            >
              <ValidationProvider
                :name="$t('colleges.colegium.college_code')"
                rules="required"
                v-slot="{ errors }"
              >
                <b-form-input
                  v-model="data.college_code"
                  type="text"
                  :placeholder="$t('colleges.colegium.college_code')"
                  :class="errors.length > 0 ? ' is-invalid' : ''"
                >
                </b-form-input>
                <div class="invalid-feedback">
                  <span>{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </b-form-group>
            <b-form-group
              class="col-md-12"
              :label="$t('colleges.colegium.password')"
              label-for="calendar_id"
            >
              <ValidationProvider
                :name="$t('colleges.colegium.password')"
                rules=""
                v-slot="{ errors }"
              >
                <b-form-input
                  v-model="data.password"
                  type="password"
                  placeholder="●●●●●●●●"
                  :class="errors.length > 0 ? ' is-invalid' : ''"
                >
                </b-form-input>
                <div class="invalid-feedback">
                  <span>{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </b-form-group>
          </b-row>
          <hr />
          <b-button
            :disabled="apiCredentialsLogin"
            variant="success"
            class="float-right"
            type="submit"
          >
            <span v-if="apiCredentialsLogin">
              <b-spinner small type="grow"></b-spinner>
              {{ $t("app.loading") }}...
            </span>
            <span v-else>
              {{ $t("app.save") }}
            </span>
          </b-button>
          <b-button
            class="float-right mr-1"
            @click="$bvModal.hide('modal-api-credentials')"
            variant="outline-danger"
            type="reset"
          >
            {{ $t("app.cancel") }}
          </b-button>
        </div>
      </form>
    </ValidationObserver>
  </b-modal>
</template>
<script>
import { core } from "@/config/pluginInit";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "modalFormApiCredentials",
  mounted() {
    core.index();
  },
  data() {
    return {
      data: {
        id: null,
        username: null,
        password: null,
        college_code: null,
      },
    };
  },
  methods: {
    ...mapActions({
      saveForm: "updateOrCreateCollegeApiCredentials",
    }),
    async show(item) {
      this.reserForm();
      if (item) {
        this.data = {
          id: item.id,
          username: item.username,
          college_code: item.college_code,
          password: "",
        };
      }
      this.$bvModal.show("modal-api-credentials");
    },
    async onSubmit() {
      const resp = await this.saveForm({
        api_name: "colegium",
        ...this.data,
        password: !this.data.id ? this.data.password : undefined,
      });
      this.$bvModal.hide("modal-api-credentials");
      this.$emit("refresh");
      if (resp.status === 201 || resp.status === 200) {
        core.showSnackbar(
          "success",
          !this.data.id
            ? this.$t("app.success-create")
            : this.$t("app.success-edit")
        );
      }
      this.reserForm();
    },
    reserForm() {
      this.data = {
        id: null,
        username: null,
        password: null,
        college_code: null,
      };
    },
  },
  computed: {
    ...mapGetters({
      apiCredentialsLogin: "apiCredentialsLogin",
    }),
  },
};
</script>
